$(window).on('load', function () {
  if (window.innerWidth < 768) {
    $('.wpcf7-form-control-wrap textarea').on('input', function () {
      $(this).css('height', 'auto');
      $(this).css('height', ($(this).get(0).scrollHeight + 15) + 'px');
    });
  }
});
